<template>
  <div class="page">
    <!-- header -->
    <header-bar :selected="selected" :cityName="cityName" @getCityId="getCityId"></header-bar>
    <!-- subnav -->
    <div class="subnav" style="margin-top:80px;">
      <ul class="navbar">
        <li class="item"><span :class="[tab=='0'?'active':'']" @click="changeTab('0')">正在热映</span></li>
        <li class="item"><span :class="[tab=='1'?'active':'']" @click="changeTab('1')">即将上映</span></li>
      </ul>
    </div>
    <!-- container -->
    <div class="container">
      <div class="main">
        <!-- 正在热映 -->
        <div class="panel">
          <div class="panel-content">
            <ul class="list">
              <li class="item-wrap" v-for="(item, index) in dataList">
                <div class="item" @click="toFilmDetail(item.mid)">
                  <div class="item-top">
                    <img :src="item.poster"/>
                  </div>
                  <div class="item-bottom">
                    <p class="title">{{item.title}}</p>
                    <p class="score" v-if="tab==0">{{item.scores}}</p>
                    <p class="wish" v-else>{{item.wish}}人想看</p>
                  </div>
                  <!-- 遮罩层 -->
                  <div class="item-info">
                    <div class="mask"></div>
                    <div class="mask-list">
                      <p>导演：{{item.direct}}</p>
                      <p>主演：{{item.player}}</p>
                      <p>类型：{{item.category}}</p>
                      <p>地区：{{item.country}}</p>
                      <p>片长：{{item.duration}}分钟</p>
                      <p>上映：{{item.show}}</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="pageNum"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-bar></footer-bar>
    <!-- 城市弹出框 -->
    <div class="mask" v-if="cityDialog"></div>
    <div class="city-list" v-if="cityDialog">
      <div class="city-title">请选择城市</div>
      <div class="city-main">
        <div class="hot-wrap">
          <span class="hot-title">热门城市：</span>
          <ul class="hot-list">
            <li class="hot-item" v-for="(item, index) in hotCityList" :key="index" @click="confirmCity(item.cityId,item.name)">{{item.name}}</li>
          </ul>
        </div>
        <ul class="all-wrap">
          <li class="all-list" v-for="(item, idx1) in allCityList" :key="idx1">
            <span class="letter">{{item.start}}</span>
            <div class="list">
              <div class="item" v-for="(cityList, idx2) in item.cityList" :key="idx2" @click="confirmCity(cityList.cityId,cityList.name)">{{cityList.name}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import headerBar from '@/components/headerBar'
  import footerBar from '@/components/footerBar'
  import {hotList, movieList, cityPosit} from '@/api/film'

  export default {
    components: {headerBar, footerBar},
    data(){
      return{
        // 选中的当前导航
        selected: "1",
        // 城市id
        cityId: '',
        // 城市名称
        cityName: '',
        // tab
        tab: this.$route.query.tab,
        // 列表数据
        dataList: [],
        // 分页
        pageNum: 1,
        pageSize: 30,
        total: 0,
        // 城市弹出框
        cityDialog: false,
        // 热门城市
        hotCityList: [],
        // 所有城市
        allCityList: []
      }
    },
    mounted() {
      //保证this实例已经插入文档
      this.$nextTick(function(){
        // 加载业务处理
        this.initBusiness();
      })
    },
    watch: {
      'cityName': function(newV, oldV){ // watch监听props里cityName的变化，然后执行操作
        this.cityName = newV;
      }
    },
    methods: {
      // 加载业务处理
      initBusiness(){
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
        // 判断本地存储是否有城市
        if(localStorage.getItem('cityId')==undefined || localStorage.getItem('cityId')==null || localStorage.getItem('cityId')==''){
          // 获取城市定位
          this.getLocation();
        }else{
          // 获取城市id
          this.cityId = localStorage.getItem('cityId');
          // 获取城市名称
          this.cityName = localStorage.getItem('cityName');
          //默认tab为正在热映
          if(!this.tab || this.tab == '0'){
            this.tab = '0';
            // 正在热映数据
            this.getHotList();
          }else if(this.tab == '1'){
            // 即将上映数据
            this.getMovieList();
          }
        }
      },
      // 获取城市定位
      getLocation(){
        var _this = this;
        if(navigator.geolocation) {
          let geolocation = new BMap.Geolocation();
          geolocation.getCurrentPosition((position)=>{
            _this.cityName = position.address.city;
            let x= position.latitude ; // ---> 与H5 中的地理定位 若navigator.geolocation.getCurrentPosition(success,error,options)  则 let x = position.coords.latitude 一样   纬度
            let y= position.longitude; // 经度
            localStorage.setItem("cityName", position.address.city);
            localStorage.setItem("latitude", x);
            localStorage.setItem("longitude", y);
            _this.cityPosit(position.address.city);
          },(error)=>{
            console.log(error.code);
            _this.cityName = "";
            // 抛异常时打开城市弹出框
            _this.cityDialog = true;
            // 热门城市和所有城市
            _this.allCity();
          },_this.options);
      　}
      },
      // 获取城市名称error时-----获取热门城市和所有城市
      allCity() {
        let data = {};
        allCity(data).then(response => {
          // 热门城市
          this.hotCityList = response.data.hotCityList;
          // 所有城市
          this.allCityList = response.data.cityAll;
        });
      },
      // 获取城市名称error时-----选择切换城市
      confirmCity(cityId, name) {
        this.cityId = cityId;
        this.cityName = name;
        localStorage.setItem('cityId', cityId);
        localStorage.setItem('cityName', name);
        // 关闭城市弹出框
        this.cityDialog = false;
        //默认tab为正在热映
        if(!this.tab || this.tab == '0'){
          this.tab = '0';
          // 正在热映数据
          this.getHotList();
        }else if(this.tab == '1'){
          // 即将上映数据
          this.getMovieList();
        }
      },
      // 根据城市名称获取城市编码
      cityPosit(cityName) {
      	let signdata = {cityName: cityName};
        let data = {cityName: cityName, signdata: signdata};
        cityPosit(data).then(response => {
          this.cityId = response.data.cityId;
          localStorage.setItem("cityId", response.data.cityId);
          //默认tab为正在热映
          if(!this.tab || this.tab == '0'){
            this.tab = '0';
            // 正在热映数据
            this.getHotList();
          }else if(this.tab == '1'){
            // 即将上映数据
            this.getMovieList();
          }
        });
      },
      // 获取子组件（headerBar）传递的值
      getCityId(cityId){
        this.cityId = cityId;
        this.pageNum = 1;
        //默认tab为正在热映
        if(!this.tab || this.tab == '0'){
          this.tab = '0';
          // 正在热映数据
          this.getHotList();
        }else if(this.tab == '1'){
          // 即将上映数据
          this.getMovieList();
        }
      },
      // tab切换
      changeTab(val){
        this.tab = val;
        this.pageNum = 1;
        this.dataList = [];
        if(val == '0'){
          this.getHotList();
        }else{
          this.getMovieList();
        }
      },
      // 正在热映数据
      getHotList() {
        let signdata = {cityId: this.cityId, page: this.pageNum};
        let data = {cityId: this.cityId, page: this.pageNum, pageSize: this.pageSize, signdata: signdata};
        hotList(data).then(response => {
          this.dataList = response.data;
          this.total = response.total;
        });
      },
      // 即将上映数据
      getMovieList() {
      	let signdata = {cityId: this.cityId, page: this.pageNum};
        let data = {cityId: this.cityId, page: this.pageNum, pageSize: this.pageSize, signdata: signdata};
        movieList(data).then(response => {
          this.dataList = response.data;
          this.total = response.total;
        });
      },
      // 跳转到影片详情
      toFilmDetail(mid){
        this.$router.push({path: '/cinemaList', query: {mid: mid}})
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        if(this.tab == '0'){
          this.getHotList();
        }else{
          this.getMovieList();
        }
        // 切换页面时滚动条自动滚动到顶部
        window.scrollTo(0,0);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /*如果浏览器小于992px时候字体是10px*/
  @media screen and (max-width:992px){
    .mask-list{
      font-size: 10px !important;
    }
  }
  /*如果浏览器大于1600px时候图片高度320*/
  @media screen and (min-width:1600px){
    .panel-content .item .item-top{
      height: 320px !important;
    }
    .item-info{
      height: 320px !important;
    }
  }
  .subnav{
    height: 60px;
    width: 100%;
    min-width: 75%;
    text-align: center;
    background-color: #47464a;
  }
  .subnav .navbar{
    margin: 0 auto;
    display: inline-block;
  }
  .subnav .navbar .item {
    display: inline-block;
    float: left;
  }
  .subnav .navbar .item span{
    display: block;
    font-size: 16px;
    color: #999;
    height: 60px;
    line-height: 60px;
    padding: 0 40px;
    cursor: pointer;
  }
  .subnav .navbar .item .active {
    position: relative;
    color: #ef4238;
    cursor: default;
  }
  .subnav .navbar .item .active:before {
    content: "";
    width: 2px;
    height: 0;
    display: inline-block;
    position: absolute;
    left: 50%;
    margin-left: -5px;
    top: 53px;
    border-bottom: 7px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: none;
  }
  .container {
    width: 75%;
    margin: 0 auto;
  }
  .main {
    overflow: hidden;
  }
  /*正在热映*/
  .panel{
    width: 100%;
  }
  .panel-content{
    margin-top: 23px;
    margin-bottom: 23px;
    width: 100%;
    overflow: hidden;
  }
  .panel-content .list{
    width: 100%;
  }
  .item-wrap{
    margin-top: 30px;
    float: left;
    width: 16.6%;
    padding-left: 1%;
    padding-right: 1%;
    box-sizing: border-box;
  }
  .panel-content .item{
    position: relative;
    /*居中后标题缩进40px(240-160=80 /2=40)*/
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
  }
  .panel-content .item .item-top{
    position: relative;
    height: 220px;
    overflow: hidden;
    background-color: #fcfcfc;
    cursor: pointer;
  }
  .panel-content .item img{
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
  }
  .panel-content .item .item-bottom{
    width: 100%;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }
  .item-bottom .title{
    margin-top: 10px;
    font-size: 16px;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-bottom .score{
    font-style: italic;
    font-weight: bold;
    font-size: 24px;
    color: #ffb400;
  }
  .item-bottom .wish{
    margin-top: 10px;
    font-weight: bold;
    font-size: 16px;
    color: #ffb400;
  }
  /*分页*/
  .pagination-container{
    margin-bottom: 62px;
  }
  /*mask*/
  .item-info{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 220px;
    color: #fff;
  }
  .mask{
    width: 100%;
    height: 0;
    opacity: .6;
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
    -webkit-transition: all .2s ease-out;
    background-color: #000;
  }
  .mask-list{
    position: absolute;
    left: 0;
    top: 0;
    padding-top: 30px;
    /*padding-left: 25px;*/
    width: 100%;
    height: 0;
    font-size: 13px;
    font-weight: 500;
    box-sizing: border-box;
    text-align: left;
    -webkit-transform: translateY(-10px);
    transform: translateY(-10px);
    -webkit-transition: all .2s ease-out;
    overflow: hidden;
  }
  .mask-list p{
    width: 80%;
    margin: 0 auto;
    line-height: 24px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .item:hover .mask{
    height: 100%;
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  .item:hover .mask-list{
    height: 100%;
    -webkit-transform: translateY(0px);
    transform: translateY(10px);
  }
</style>


// WEBPACK FOOTER //
// src/views/filmList.vue